var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "input" }, [
    "text" === "checkbox"
      ? _c(
          "input",
          _vm._b(
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.context.model,
                  expression: "context.model"
                }
              ],
              staticClass: "border p-2 w-full rounded",
              style: _vm.visible ? "" : _vm.passwordMaskStyle,
              attrs: { type: "checkbox" },
              domProps: {
                checked: Array.isArray(_vm.context.model)
                  ? _vm._i(_vm.context.model, null) > -1
                  : _vm.context.model
              },
              on: {
                input: function($event) {
                  return _vm.$emit("input", $event.target.value)
                },
                change: function($event) {
                  var $$a = _vm.context.model,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 &&
                        _vm.$set(_vm.context, "model", $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        _vm.$set(
                          _vm.context,
                          "model",
                          $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                        )
                    }
                  } else {
                    _vm.$set(_vm.context, "model", $$c)
                  }
                }
              }
            },
            "input",
            _vm.context.attributes,
            false
          )
        )
      : "text" === "radio"
      ? _c(
          "input",
          _vm._b(
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.context.model,
                  expression: "context.model"
                }
              ],
              staticClass: "border p-2 w-full rounded",
              style: _vm.visible ? "" : _vm.passwordMaskStyle,
              attrs: { type: "radio" },
              domProps: { checked: _vm._q(_vm.context.model, null) },
              on: {
                input: function($event) {
                  return _vm.$emit("input", $event.target.value)
                },
                change: function($event) {
                  return _vm.$set(_vm.context, "model", null)
                }
              }
            },
            "input",
            _vm.context.attributes,
            false
          )
        )
      : _c(
          "input",
          _vm._b(
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.context.model,
                  expression: "context.model"
                }
              ],
              staticClass: "border p-2 w-full rounded",
              style: _vm.visible ? "" : _vm.passwordMaskStyle,
              attrs: { type: "text" },
              domProps: { value: _vm.context.model },
              on: {
                input: [
                  function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.context, "model", $event.target.value)
                  },
                  function($event) {
                    return _vm.$emit("input", $event.target.value)
                  }
                ]
              }
            },
            "input",
            _vm.context.attributes,
            false
          )
        ),
    _vm._v(" "),
    _vm.visible
      ? _c("span", {
          staticClass: "icon icon--eye-closed",
          on: {
            click: function($event) {
              _vm.visible = !_vm.visible
            }
          }
        })
      : _c("span", {
          staticClass: "icon icon--eye",
          on: {
            click: function($event) {
              _vm.visible = !_vm.visible
            }
          }
        })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }